<template>
  <div>
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>学员跟踪记录</el-breadcrumb-item>
      <el-breadcrumb-item>学员服务记录</el-breadcrumb-item>
      <el-breadcrumb-item>{{queryParam.uid}}-{{queryParam.nickName}}</el-breadcrumb-item>
    </el-breadcrumb>
    <div style="margin-top: 20px">
      <div class="block">
        <span class="demonstration">添加时间：</span>
        <el-date-picker
          v-model="addTime"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
        <span class="demonstration">下次联系时间：</span>
        <el-date-picker
          v-model="time"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期">
        </el-date-picker>
        <div class="block">
        <span class="demonstration">下次联系人：</span>
        <el-select v-model="queryParam.nextHandlerId" placeholder="请选择" clearable filterable>
          <el-option
            v-for="item in adminList"
            :key="item.id"
            :label="item.nickname"
            :value="item.id">
          </el-option>
        </el-select>
          <span class="demonstration">操作人：</span>
          <el-input v-model="queryParam.createName" placeholder="支持模糊搜索" style="width: 15%" size="medium"></el-input>
          <span class="demonstration">记录属性：</span>
          <el-select v-model="queryParam.trackTypeStr" placeholder="请选择" clearable>
            <el-option label="新注册学生" value="(1)">新注册学生</el-option>
            <el-option label="分配记录" value="(11)">分配记录</el-option>
            <el-option label="试听课记录" value="(21,22,23,24,25)">试听课记录</el-option>
            <el-option label="成交记录" value="(31,32)">成交记录</el-option>
            <el-option label="交接记录" value="(41,42,43)">交接记录</el-option>
            <el-option label="绑定记录" value="(51,52)">绑定记录</el-option>
            <el-option label="上课跟进记录" value="(61,62,63,64,65,66,67,68)">上课跟进记录</el-option>
            <el-option label="其他" value="(99)">其他</el-option>
          </el-select>
      </div>
      </div>
        <div class="block">
          <span class="demonstration">学生：{{queryParam.uid}}-{{queryParam.nickName}}</span>
          <span class="demonstration">课程顾问：{{adviserName}}</span>
          <span class="demonstration">学习导师：{{studyAdviserName}}</span>
          <span class="demonstration">绑定老师：{{bindTch}}</span>
        <el-button type="primary" icon="el-icon-search" @click="search" :loading="onLoading" style="margin-left: 5px">搜索</el-button>
          <el-button type="primary"
                  @click="addTrace">添加记录
          </el-button>
      </div>
    </div>
    <table class="track-list">
      <thead>
        <tr>
          <th width="5%">记录属性</th>
          <th width="10%">添加时间</th>
          <th width="50%">内容</th>
          <th class="next-handler-time-col">下次联系日期</th>
          <th width="10%">下次联系人</th>
          <th width="5%">操作人</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in tableData">
          <td :rowspan="item.rowSpan" :hidden="item.hidden">{{item.showName}}</td>
          <td>
            <span>{{item.createTime}}</span>
          </td>
          <td>
            <TrackContentPreview :content="item.content" @view="openContentView(item)" />
          </td>
          <td class="next-handler-time-col">
            <span class="next-handler-time-text" :title="formatNextHandlerTime(item)">{{formatNextHandlerTime(item)}}</span>
          </td>
          <td>{{item.nextHandlerName}}</td>
          <td>{{item.createName}}</td>
        </tr>
      </tbody>
    </table>
    <Page :total="queryParam.totalCount" show-elevator className="page" :current="queryParam.pageIndex"
          :pageSize="queryParam.pageSize" @on-change="changePageIndex" show-total></Page>
    <Modal v-model="contentVisible" title="跟踪记录内容" width="720" :mask-closable="false">
      <div style="margin-bottom: 12px;">
        <Radio-group v-model="contentViewMode" type="button" size="small" @on-change="switchContentView">
          <Radio label="markdown">Markdown</Radio>
          <Radio label="raw" :disabled="!contentRawText">原文</Radio>
        </Radio-group>
        <span v-if="!contentRawText" style="margin-left:8px;color:#999;font-size:12px;">无原始内容</span>
      </div>
      <div v-if="contentViewMode === 'markdown'" ref="contentExportArea" class="track-md track-md-dialog" v-html="contentHtml"></div>
      <pre v-else ref="contentExportArea" class="track-raw-dialog">{{ contentRawText }}</pre>
      <div slot="footer">
        <Button :loading="exportImageLoading" :disabled="exportImageLoading || (contentViewMode==='markdown' ? !contentHtml : !contentRawText)" @click="exportContentPng">导出 PNG</Button>
        <Button type="primary" @click="contentVisible = false">关闭</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
  import { renderSimpleMarkdown } from '@/utils/simpleMarkdown'
  import html2canvas from 'html2canvas'
  import TrackContentPreview from './TrackContentPreview.vue'
  export default {
    components: { TrackContentPreview },
    props: {
      showData: {
        type: Object,
        default () {
          return null
        },
      },
    },
    data () {
      return {
        bindTch: '',
        adviserName: '',
        studyAdviserName: '',
        tableData: [],
        rowTypeCount: 1,
        rowSpanList: [],
        spanRow: [],
        count: 0,
        index: 0,
        span: 1,
        onLoading: false,
        adminList: [],
        queryParam: {
          trackTypeStr: '',
          trackType: '',
          totalCount: 0,
          pageSize: 10,
          pageIndex: 1,
          id: '',
          uid: '',
          nickName: '',
          mobile: '',
          content: '',
          startTimeDate: '',
          endTimeDate: '',
          nextHandlerId: '',
          startTime: '',
          endTime: '',
          traceType: '',
          createStartTime: '',
          createEndTime: '',
          createName: '',
        },
        time: [],
        addTime: [],
        contentVisible: false,
        contentHtml: '',
        contentRawText: '',
        contentViewMode: 'markdown',
        contentMeta: {},
        exportImageLoading: false,
      }
    },
    methods: {
      renderContent (content) {
        return renderSimpleMarkdown(content)
      },
      openContentView (item) {
        if (!item || !item.content) {
          this.$Message.warning('暂无内容')
          return
        }
        this.contentMeta = {
          uid: item.uid || this.queryParam.uid || '',
          id: item.id || '',
          createTime: item.createTime || ''
        }
        this.contentHtml = renderSimpleMarkdown(item.content)
        this.contentRawText = item.contentRaw || ''
        this.contentViewMode = 'markdown'
        this.contentVisible = true
      },
      switchContentView () {
        // Radio 切换即可；导出区用同一 ref
      },
      exportContentPng () {
        let el = this.$refs.contentExportArea
        if (!el || (this.contentViewMode === 'markdown' ? !this.contentHtml : !this.contentRawText)) {
          this.$Message.warning('暂无内容可导出')
          return
        }
        this.exportImageLoading = true
        let self = this
        // Modal body / .track-md-dialog 有 max-height+overflow，html2canvas 只会截可见区。
        // 离屏克隆整页高度再截（参考 LevelRecordList 的 scrollWidth/Height），弹窗内仍可滚动查看。
        let width = Math.max(el.clientWidth || 0, 680)
        let holder = document.createElement('div')
        holder.setAttribute('data-track-png-export', '1')
        holder.style.cssText = 'position:absolute;left:-10000px;top:0;width:' + width + 'px;background:#fff;'
        let clone = el.cloneNode(true)
        clone.className = (el.className || '').replace(/\btrack-md-dialog\b/g, ' ').replace(/\s+/g, ' ').trim()
        if ((' ' + clone.className + ' ').indexOf(' track-md ') < 0) {
          clone.className = (clone.className + ' track-md').trim()
        }
        clone.style.cssText = 'max-height:none!important;overflow:visible!important;height:auto!important;width:' + width + 'px;background:#fff;padding:8px;box-sizing:border-box;'
        holder.appendChild(clone)
        document.body.appendChild(holder)
        let cleanup = function () {
          if (holder && holder.parentNode) {
            holder.parentNode.removeChild(holder)
          }
        }
        void clone.offsetHeight
        let w = Math.max(clone.scrollWidth, width)
        let h = Math.max(clone.scrollHeight, clone.offsetHeight, 1)
        html2canvas(clone, {
          scale: 2,
          backgroundColor: '#ffffff',
          useCORS: true,
          logging: false,
          width: w,
          height: h,
          windowWidth: w,
          windowHeight: h
        }).then(canvas => {
          cleanup()
          let meta = self.contentMeta || {}
          let stamp = String(meta.createTime || '').replace(/[^\d]/g, '')
          let link = document.createElement('a')
          link.download = '跟踪记录_' + (meta.uid || '') + (meta.id ? '_' + meta.id : '') + (stamp ? '_' + stamp : '') + '.png'
          link.href = canvas.toDataURL('image/png')
          link.click()
          self.exportImageLoading = false
          self.$Message.success('导出成功')
        }).catch(() => {
          cleanup()
          self.exportImageLoading = false
          self.$Message.error('导出失败')
        })
      },
      formatNextHandlerTime (item) {
        let t = item && item.nextHandlerTime
        if (!t || t === '0000-00-00 00:00:00') {
          return '0'
        }
        return t
      },
      addTrace () {
        this.$router.push('/user/userTrackEdit?uid=' + this.queryParam.uid)
      },
      changePageIndex (page) {
        this.queryParam.pageIndex = page
        this.getPersonTrace(this.queryParam.uid)
      },
      search () {
        let self = this
        self.onLoading = true
        let params = self.queryParam
        params.pageIndex = 1
        self.$http.post('/userTrack/getPersonTrace', params).then(function (res) {
          self.onLoading = false
          if (!res.data || !res.data.data) {
            self.queryParam.totalCount = 0
            self.tableData = []
            return
          }
          self.queryParam.uid = res.data.data[0].uid
          self.queryParam.nickName = res.data.data[0].nickname
          self.queryParam.mobile = res.data.data[0].mobile
          self.queryParam.totalCount = res.data.totalCount
          // self.generateContent(res.data.data)
          self.tableData = res.data.data
          self.getTypeCount(res.data.data)
        })
      },
      goOnTrack (row) {
        this.queryParam.id = row.id
        this.queryParam.traceType = row.trackType
        this.$router.push({path: '/user/userTrackEdit', query: this.queryParam})
      },
      getTypeCount (val) {
        let self = this
        let listIndex = 0
        if (val) {
          self.rowSpanList[listIndex] = 1
          for (var index = 0; index < val.length; index++) {
            if (val[index + 1]) {
              if (val[index].showType === val[index + 1].showType) {
                self.rowSpanList[listIndex] = self.rowSpanList[listIndex] + 1
              } else {
                listIndex++
                self.rowSpanList[listIndex] = 1
              }
            }
          }
        }
        this.setColSpanNum(this.tableData)
      },
      setColSpanNum (val) {
        let self = this
        self.count = 0
        for (var i = 0; i < val.length; i++) {
          val[i].rowSpan = 1
          val[i].hidden = false
          if (val[i - 1]) {
            if (val[i].showType === val[i - 1].showType) {
              val[i].hidden = true
            }
          }
        }
        for (var index = 0; index < self.rowSpanList.length; index++) {
          if (!val[self.count]) {
            return
          }
          val[self.count].rowSpan = self.rowSpanList[index]
          self.count = self.count + self.rowSpanList[index]
        }
      },
      // 处理个人跟踪记录
      generateContent (data) {
        if (data) {
          for (var index = 0; index < data.length; index++) {
            this.creatContent(data[index], null)
            this.nodeToList(null, data[index])
          }
        }
      },
      creatContent (oldData, newData) {
        if (oldData) {
          if (newData) {
            if (newData.traceNode) {
              this.creatContent(oldData, newData.traceNode)
            } else {
              oldData.nextHandlerTime = newData.nextHandlerTime
              oldData.nextHandlerName = newData.nextHandlerName
              oldData.operateStatus = newData.operateStatus
            }
          } else {
            if (oldData.traceNode) {
              this.creatContent(oldData, oldData.traceNode)
            }
          }
        }
      },
      // 链表转数组
      nodeToList (val, oldVal) {
        if (!val) {
          if (oldVal) {
            if (!oldVal.list) {
              oldVal.list = []
              oldVal.list.push(oldVal.content)
              if (oldVal.traceNode) {
                this.nodeToList(oldVal.traceNode, oldVal)
              }
            }
          }
        } else {
          oldVal.list.push(val.content)
          if (val.traceNode) {
            this.nodeToList(val.traceNode, oldVal)
          }
        }
      },
      getPersonTrace (uid) {
        let self = this
        let params = self.queryParam
        if (uid) {
          self.$http.get('/userTrack/getPersonTrace?uid=' + uid + '&pageIndex=' + params.pageIndex + '&pageSize=' + params.pageSize + '&createName=' +
          params.createName + '&createStartTime=' + params.createStartTime + '&createEndTime=' + params.createEndTime +
          '&startTime=' + params.startTime + '&endTime=' + params.endTime + '&nextHandlerId=' + params.nextHandlerId + '&trackType=' + params.trackType).then(function (res) {
            if (!res.data.data || !res.data.data[0]) {
              self.queryParam.totalCount = 0
              return
            }
            self.queryParam.totalCount = res.data.totalCount
            self.queryParam.pageIndex = res.data.pageIndex
            self.queryParam.pageSize = res.data.pageSize
            self.queryParam.uid = res.data.data[0].uid
            self.queryParam.nickName = res.data.data[0].nickname
            self.queryParam.mobile = res.data.data[0].mobile
            self.generateContent(res.data.data)
            self.tableData = res.data.data
            self.getTypeCount(res.data.data)
          })
          self.$http.post('/adminUser/listByCondition', {status: 1}).then(function (res) {
            if (res.data) {
              self.adminList = res.data
            }
          })
        }
      },
    },
    created: function () {
      let self = this
      self.queryParam.uid = localStorage.getItem('userTraceUid')
      let uid = self.queryParam.uid
      self.$http.get('/user/queryById?uid=' + uid).then(function (res) {
        if (res.data) {
          if (res.data.firstName) {
            self.bindTch = res.data.firstName + res.data.lastName
          } else {
            self.bindTch = ''
          }
          self.adviserName = res.data.adviserName
          self.studyAdviserName = res.data.studyAdviserName
        }
      })
      self.getPersonTrace(uid)
    },
    mounted: function () {
    },
    watch: {
      addTime (val) {
        if (!val) {
          this.queryParam.createStartTime = ''
          this.queryParam.createEndTime = ''
          return
        }
        if (val[0]) {
          let left = Date.parse(val[0])
          this.queryParam.createStartTime = left / 1000
        }
        if (val[1]) {
          let right = Date.parse(val[1])
          this.queryParam.createEndTime = right / 1000 + 86399
        }
      },
      time (val) {
        if (!val) {
          this.queryParam.startTime = ''
          this.queryParam.endTime = ''
          return
        }
        if (val[0]) {
          let left = Date.parse(val[0])
          this.queryParam.startTime = left / 1000
        }
        if (val[1]) {
          let right = Date.parse(val[1])
          this.queryParam.endTime = right / 1000 + 86399
        }
      }
    }
  }
</script>

<style scoped>
.track-list {
  table-layout: fixed;
  width: 100%;
}
.next-handler-time-col {
  width: 120px;
  max-width: 120px;
}
.next-handler-time-text {
  display: inline-block;
  width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: middle;
}

.track-md { text-align: left; line-height: 1.5; font-size: 14px; }
.track-raw-dialog {
  max-height: 60vh;
  overflow: auto;
  white-space: pre-wrap;
  word-break: break-word;
  margin: 0;
  padding: 8px;
  background: #fafafa;
  border: 1px solid #eee;
  font-size: 13px;
  line-height: 1.6;
}
.track-md-dialog {
  max-height: 60vh;
  overflow: auto;
  background: #fff;
  padding: 8px 4px;
}
.track-md /deep/ .md-table { border-collapse: collapse; width: 100%; margin: 4px 0; }
.track-md /deep/ .md-table th, .track-md /deep/ .md-table td { border: 1px solid #e8e8e8; padding: 2px 6px; }
.track-md /deep/ h2, .track-md /deep/ h3, .track-md /deep/ h4 { margin: 6px 0 4px; font-size: 14px; }
.track-md /deep/ ul, .track-md /deep/ ol { padding-left: 18px; margin: 4px 0; }
.track-md /deep/ blockquote { margin: 4px 0; padding-left: 8px; border-left: 3px solid #ddd; color: #666; }
.track-md /deep/ p { margin: 2px 0; }
</style>



// WEBPACK FOOTER //
// PersonUserTrackList.vue?67158d09